/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Section_CreditsInputs */



/**
* | output |
* | --- |
* | "Token Credits & Usage" |
*
* @param {Faq_Section_CreditsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const faq_section_credits = /** @type {((inputs?: Faq_Section_CreditsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Section_CreditsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Token-Credits & Nutzung")
	return /** @type {LocalizedString} */ ("Token Credits & Usage")
});